<template>
  <card class="collapsed">
    <template slot="header">
      <h5 class="card-title mb-0">{{ this.instrument.na }}</h5>
      <h3 class="card-title">
        {{ this.currentPosition ? "Modifier ma" : "Prendre une" }} position
      </h3>
    </template>
    <tabs
      type="primary"
      tabNavWrapperClasses="col-lg-2 col-md-4"
      tabContentClasses="col-lg-10 col-md-8"
      vertical
      square
      class="row"
    >
      <tab-pane>
        <span slot="label">
          <i class="tim-icons icon-cart"></i>Ma position
        </span>
        <form
          class="form-horizontal"
          action="#"
          method="#"
          @submit.prevent="updatePosition"
        >
          <div class="row">
            <div class="col-12 col-md-6">
              <h6 class="text-center">Positions actuelle</h6>
              <div class="row">
                <label class="col-md-6 col-form-label">{{
                  mode !== "crypto" ? "Nombre de titres" : "Quantité"
                }}</label>
                <div class="col-md-6">
                  <base-input
                    name="quantity"
                    v-model="positionModel.quantity"
                    v-validate="modelValidations.quantity"
                    :error="getError('quantity')"
                    placeholder="0"
                    type="number"
                    step="any"
                  >
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-md-6 col-form-label"
                  >Prix de revient unitaire</label
                >
                <div class="col-md-6">
                  <base-input
                    name="value"
                    v-model="positionModel.value"
                    v-validate="modelValidations.value"
                    :placeholder="this.instrument.li.last"
                    type="number"
                    step="any"
                  >
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-md-6 col-form-label">Niveau de stop</label>
                <div class="col-md-6">
                  <base-input
                    name="stop"
                    v-model="positionModel.stop"
                    v-validate="modelValidations.stop"
                    :placeholder="
                      (this.instrument.in.st
                        ? this.instrument.in.st
                        : this.instrument.li.last * 0.85
                      ).toFixed(this.instrument.pd)
                    "
                    type="number"
                    step="any"
                  >
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 text-center" v-if="positionInfo">
              <h6 class="mb-4">Informations complémentaires</h6>

              <div class="info-plus">
                <b>{{ positionInfo.total }} {{ this.cur }}</b> engagés
              </div>
              <div class="info-less text-muted">
                Soit
                <b
                  v-bind:class="{
                    'text-danger': positionInfo.percentCapital > 20
                  }"
                  >{{ positionInfo.percentCapital }}%</b
                >
                du portefeuille
              </div>

              <div v-if="positionInfo.loss < 0">
                <div class="info-plus mt-2">
                  <b class="text-danger"
                    >{{ positionInfo.loss }} {{ this.cur }}</b
                  >
                  risqués
                </div>
                <div class="info-less text-muted">
                  avec un stop perte fixé à
                  <b>{{ positionInfo.percentLoss }}%</b>
                </div>
              </div>

              <div v-if="positionInfo.loss > 0">
                <div class="info-plus mt-2">
                  <b class="text-success"
                    >{{ positionInfo.loss }} {{ this.cur }}</b
                  >
                  sécurisés
                </div>
                <div class="info-less text-muted">
                  avec un stop gain fixé à
                  <b>{{ Math.abs(positionInfo.percentLoss) }}%</b>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 offset-md-3 col-12">
              <base-button class="mt-3" native-type="submit" type="primary">
                Enregistrer
              </base-button>
              <base-button
                v-if="this.currentPosition"
                class="mt-3"
                type="primary"
                simple
                @click.native="removePosition()"
              >
                Supprimer
              </base-button>
            </div>
          </div>
        </form>
      </tab-pane>

      <tab-pane>
        <span slot="label">
          <i class="tim-icons icon-controller"></i>Calculette
        </span>
        <form
          class="form-horizontal"
          action="#"
          method="#"
          @submit.prevent="updateCalculation"
        >
          <div class="row">
            <div class="col-12 mb-4">
              <h6 class="text-center">Calcul de taille de position</h6>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <label class="col-md-6 col-form-label text-right"
                  >Valeur d'achat ({{ cur }})</label
                >
                <div class="col-md-6">
                  <base-input
                    name="buyPrice"
                    v-model="calculatorModel.buyPrice"
                    v-validate="calculatorModelValidations.buyPrice"
                    placeholder="12.34"
                    type="number"
                    step="any"
                  ></base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-md-6 col-form-label text-right"
                  >Stop loss ({{ cur }})</label
                >
                <div class="col-md-6">
                  <base-input
                    name="stopLoss"
                    v-model="calculatorModel.stopLoss"
                    v-validate="calculatorModelValidations.stopLoss"
                    placeholder="0"
                    type="number"
                    step="any"
                  ></base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-md-6 col-form-label text-right"
                  >Risque de perte<br />en capital (%)</label
                >
                <div class="col-md-6">
                  <base-input
                    name="maxLoss"
                    v-model="calculatorModel.maxLoss"
                    v-validate="calculatorModelValidations.maxLoss"
                    placeholder="0"
                    type="number"
                    step="any"
                  ></base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-md-6 col-form-label text-right"
                  >Prix cible ({{ cur }})</label
                >
                <div class="col-md-6">
                  <base-input
                    name="targetPrice"
                    v-model="calculatorModel.targetPrice"
                    v-validate="calculatorModelValidations.targetPrice"
                    placeholder="0"
                    type="number"
                    step="any"
                  ></base-input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 text-center" v-if="calculatorResult">
              <div class="row pt-3 calculator">
                <div class="col-4 text-info font-weight-bold">
                  <div class="quantity">{{ calculatorResult.quantity }}</div>
                  <div class="">titres</div>
                </div>
                <div class="col-8 text-left">
                  <div class="info-plus">
                    <b>{{ calculatorResult.total }} {{ this.cur }}</b> engagés
                  </div>
                  <div class="info-less text-muted">
                    Soit
                    <b
                      v-bind:class="{
                        'text-danger': calculatorResult.percentCapital > 20
                      }"
                      >{{ calculatorResult.percentCapital }}%</b
                    >
                    du portefeuille
                  </div>

                  <div class="info-plus mt-2">
                    <b>{{ calculatorResult.loss }} {{ this.cur }}</b> risqués
                  </div>
                  <div class="info-less text-muted">
                    avec un stop fixé à
                    <b
                      v-bind:class="{
                        'text-danger': calculatorResult.percentLoss > 20
                      }"
                      >{{ calculatorResult.percentLoss }}%</b
                    >
                  </div>

                  <div
                    v-if="calculatorModel.targetPrice"
                    class="info-plus mt-2"
                  >
                    <b>{{ calculatorResult.gain }} {{ this.cur }}</b> PV ciblées
                  </div>
                  <div
                    v-if="
                      calculatorModel.targetPrice && calculatorModel.stopLoss
                    "
                    class="info-less text-muted"
                  >
                    Cible à <b>{{ calculatorResult.percentGain }}%</b>, RRR de
                    <b>{{
                      (calculatorResult.gain / -calculatorResult.loss).toFixed(
                        2
                      )
                    }}</b>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="text-small"><i>En savoir plus sur les stops</i></div> -->

            <div class="col-12 text-center">
              <base-button class="mt-3" type="primary" native-type="submit">
                Calculer
              </base-button>
            </div>
          </div>
        </form>
      </tab-pane>
    </tabs>
  </card>
</template>

<script>
import { TabPane, Tabs, Collapse, CollapseItem } from "src/components";
import { mapGetters } from "vuex";

export default {
  name: "position",
  props: {
    instrument: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TabPane,
    Tabs
    // Collapse,
    // CollapseItem
  },
  computed: {
    currentPosition() {
      return this.$store.getters["auth/getPosition"](this.instrument.isin);
    },
    ...mapGetters({
      userConf: "auth/conf",
      mode: "auth/mode"
    }),
    cur() {
      return this.mode === "pea" ? "€" : "$";
    },
    modelValidations() {
      return {
        quantity:
          this.mode !== "crypto" ? { numeric: true } : { decimal: true },
        value: {
          decimal: true
        },
        stop: {
          decimal: true
        }
      };
    }
  },
  provide() {
    return {
      animationDuration: this.animationDuration
    };
  },
  data() {
    return {
      positionModel: {
        quantity: null,
        value: null,
        stop: null
      },
      positionInfo: null,

      calculatorModel: {
        buyPrice: null,
        stopLoss: null,
        maxLoss: null,
        targetPrice: null
      },
      calculatorResult: null,
      calculatorModelValidations: {
        buyPrice: {
          decimal: true
        },
        stopLoss: {
          decimal: true
        },
        maxLoss: {
          decimal: true
        },
        targetPrice: {
          decimal: true
        }
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async updatePosition() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // Before update, determine if this is the first position
        const firstPosition = !this.currentPosition;
        const previousPosition = { ...this.currentPosition };

        this.$store.dispatch("auth/updatePosition", {
          isin: this.instrument.isin,
          ...this.positionModel
        });

        // the user bought
        const newQuantity = parseFloat(this.positionModel.quantity);
        const prevQuantity = parseFloat(previousPosition.quantity);
        if (firstPosition || newQuantity > prevQuantity) {
          let cashUpdate = parseFloat(
            newQuantity * parseFloat(this.positionModel.value)
          ).toFixed(2);
          let title = `Souhaitez-vous retirer les ${cashUpdate +
            this
              .cur} correspondant à cet achat de votre couverture disponible ?`;

          if (!firstPosition) {
            const positionBefore =
              prevQuantity * parseFloat(previousPosition.value);
            const positionAfter =
              newQuantity * parseFloat(this.positionModel.value);
            cashUpdate = parseFloat(positionAfter - positionBefore).toFixed(2);
            title = `Souhaitez-vous retirer les ${cashUpdate +
              this
                .cur}, correspondant à votre pyramidage, de votre couverture disponible ?`;
          }

          this.$swal({
            title: "Position enregistrée !",
            text: title,
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Confirmer",
            cancelButtonText: "Ignorer",
            showCloseButton: true
          }).then(result => {
            if (result.isConfirmed) {
              this.$store.dispatch("auth/updateconf", {
                cash: parseFloat(this.userConf.cash - cashUpdate)
              });
              this.$swal(
                "C'est fait !",
                "Votre couverture disponible est maintenant de " +
                  parseFloat(this.userConf.cash - cashUpdate).toFixed(2) +
                  this.cur +
                  ".",
                "success"
              );
            }
          });
        } else if (newQuantity < prevQuantity) {
          const quantity = prevQuantity - newQuantity;
          this.$swal({
            input: "text",
            inputPlaceholder: "12.34",
            title: `Vous avez allégé de ${quantity} titres ?`,
            text:
              "Saisissez votre prix de vente unitaire pour ajuster automatiquement votre couverture disponible.",
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Confirmer",
            cancelButtonText: "Ignorer",
            showCloseButton: true
          }).then(result => {
            if (result.isConfirmed) {
              const sellPrice = parseFloat(result.value.replace(/,/g, "."));
              const cashAdd = parseFloat(sellPrice * quantity).toFixed(2);

              // Update sell price
              const index = this.userConf.positions.findIndex(
                p => p.isin === this.instrument.isin
              );
              if (this.userConf.positions[index].history) {
                this.userConf.positions[index].history[
                  this.userConf.positions[index].history.length - 1
                ].s = sellPrice;
              }

              this.$store.dispatch("auth/updateconf", {
                cash: parseFloat(this.userConf.cash + sellPrice * quantity),
                positions: this.userConf.positions
              });
              const pv =
                (sellPrice - parseFloat(previousPosition.value)) * quantity;
              this.$swal({
                title: "C'est fait !",
                icon: "success",
                html:
                  `Votre couverture disponible augmente de <b class="text-primary">${cashAdd +
                    this.cur}</b>.` +
                  `<br>Votre vente a généré une ${
                    pv < 0 ? "moins" : "plus"
                  }-value de <b class="text-${
                    pv < 0 ? "danger" : "success"
                  }">${parseFloat(pv).toFixed(2) + this.cur}</b>.`,
                showCloseButton: true
              });
            }
          });
        }
      }
      this.updatePositionInfo();
    },
    removePosition() {
      const quantity = parseInt(this.positionModel.quantity);
      const buyPrice = this.positionModel.value
        ? this.positionModel.value.replace
          ? parseFloat(this.positionModel.value.replace(/,/g, "."))
          : this.positionModel.value
        : 0;
      this.$swal({
        input: "text",
        inputPlaceholder: "12.34",
        title: "Avant de solder votre ligne...",
        text:
          "Saisissez votre prix de vente unitaire pour ajuster automatiquement votre couverture disponible.",
        showCancelButton: true,
        confirmButtonText: "Confirmer",
        cancelButtonText: "Ignorer",
        showCloseButton: true
      }).then(result => {
        if (result.dismiss != "close" || result.isConfirmed) {
          // Clear
          this.$store.dispatch("auth/removePosition", {
            isin: this.instrument.isin,
            sellPrice: parseFloat(result.value.replace(/,/g, "."))
          });
          this.positionModel = {
            quantity: null,
            value: null,
            stop: null
          };
        }
        if (result.isConfirmed) {
          const sellPrice = parseFloat(result.value.replace(/,/g, "."));
          const cashAdd = parseFloat(sellPrice * quantity).toFixed(2);
          const pv = (sellPrice - buyPrice) * quantity;
          this.$swal({
            title: "C'est fait !",
            icon: "success",
            html:
              `Votre couverture disponible augmente de <b class="text-primary">${cashAdd +
                this.cur}</b>.` +
              `<br>Votre position a généré une ${
                pv < 0 ? "moins" : "plus"
              }-value de <b class="text-${
                pv < 0 ? "danger" : "success"
              }">${parseFloat(pv).toFixed(2) + this.cur}</b>.`,
            showCloseButton: true
          }).then(() => {
            this.$store.dispatch("auth/updateconf", {
              cash: parseFloat(this.userConf.cash + sellPrice * quantity)
            });
          });
        }
      });
    },
    updateCalculation() {
      const totalPortfolio = this.$store.getters["instruments/totalPortfolio"](
        this.userConf
      );

      const avgMaxLoss = (totalPortfolio * this.calculatorModel.maxLoss) / 100;
      let quantity =
        avgMaxLoss /
        (this.calculatorModel.buyPrice - this.calculatorModel.stopLoss);
      if (this.mode !== "crypto") quantity = Math.floor(quantity);
      else quantity = Math.round(quantity * 1000000) / 1000000;

      this.calculatorResult = {
        quantity: quantity,
        total: parseFloat(quantity * this.calculatorModel.buyPrice).toFixed(2),
        percentCapital: parseFloat(
          ((quantity * this.calculatorModel.buyPrice) / totalPortfolio) * 100
        ).toFixed(1),
        loss: parseFloat(
          (this.calculatorModel.stopLoss - this.calculatorModel.buyPrice) *
            quantity
        ).toFixed(2),
        percentLoss: parseFloat(
          100 -
            (100 * this.calculatorModel.stopLoss) /
              this.calculatorModel.buyPrice
        ).toFixed(1),
        gain: parseFloat(
          (this.calculatorModel.targetPrice - this.calculatorModel.buyPrice) *
            quantity
        ).toFixed(2),
        percentGain: parseFloat(
          -100 +
            (100 * this.calculatorModel.targetPrice) /
              this.calculatorModel.buyPrice
        ).toFixed(1)
      };
    },
    initCalculator() {
      // Init calculator
      let stop = Math.min(
        this.instrument.li.last * (this.mode !== "crypto" ? 0.93 : 0.85)
      );
      this.calculatorModel = {
        buyPrice: parseFloat(this.instrument.li.last).toFixed(
          this.instrument.pd
        ),
        stopLoss: parseFloat(stop).toFixed(this.instrument.pd),
        targetPrice: null,
        maxLoss: 1
      };
      this.calculatorResult = false;
    },
    updatePositionInfo() {
      const totalPortfolio = this.$store.getters["instruments/totalPortfolio"](
        this.userConf
      );
      const avgMaxLoss = (totalPortfolio * this.positionModel.maxLoss) / 100;
      const currentValue = this.instrument.li.last;
      this.positionInfo = {
        total: parseFloat(this.positionModel.quantity * currentValue).toFixed(
          2
        ),
        percentCapital: parseFloat(
          ((this.positionModel.quantity * currentValue) / totalPortfolio) * 100
        ).toFixed(1),
        loss: parseFloat(
          (this.positionModel.stop - this.positionModel.value) *
            this.positionModel.quantity
        ).toFixed(2),
        percentLoss: parseFloat(
          100 - (100 * this.positionModel.stop) / this.positionModel.value
        ).toFixed(1)
      };
    },
    initPositionForm() {
      if (this.currentPosition) {
        this.positionModel = {
          quantity: this.currentPosition.quantity,
          value: this.currentPosition.value,
          stop: this.currentPosition.stop
        };
        this.updatePositionInfo();
      } else {
        this.positionModel = {
          quantity: null,
          value: null,
          stop: null
        };
        this.positionInfo = false;
      }
    }
  },
  mounted() {
    this.initPositionForm();
    this.initCalculator();
  },
  watch: {
    instrument(newValue, oldValue) {
      if (newValue.isin != oldValue.isin) {
        this.initPositionForm();
        this.initCalculator();
      }
    }
  }
};
</script>

<style scoped>
.calculator .quantity {
  font-size: 34px;
}
.calculator .info-plus {
  font-size: 16px;
}
.calculator .info-less {
  font-size: 11px;
}
</style>
